export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_2344bf60-af92-47ff-b547-f2298fdb3eb5/artifacts/wk895y4w_C81488C1-1A38-4765-B671-6EDA34F86861.png";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const CATEGORIES = [
  { key: "todos", label: "Todos", value: "todos", testid: "category-tab-todos" },
  { key: "talleres", label: "Talleres", value: "taller", testid: "category-tab-talleres" },
  { key: "cursos", label: "Cursos", value: "curso", testid: "category-tab-cursos" },
  { key: "diplomados", label: "Diplomados", value: "diplomado", testid: "category-tab-diplomados" },
  { key: "masters", label: "Masters", value: "master", testid: "category-tab-masters" },
];

export const CATEGORY_LABEL = {
  taller: "Taller",
  curso: "Curso",
  diplomado: "Diplomado",
  master: "Master",
};
